import { render, staticRenderFns } from "./CustomDrawer.vue?vue&type=template&id=79952503&scoped=true&"
import script from "./CustomDrawer.vue?vue&type=script&lang=js&"
export * from "./CustomDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CustomDrawer.vue?vue&type=style&index=0&id=79952503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79952503",
  null
  
)

export default component.exports